import BasicContentImage from './BasicContentImage';

export { type BasicContentImageProps } from './BasicContentImage';
export default BasicContentImage;
